import React, {useState, Fragment, useCallback, Suspense} from 'react';
import { Card, CardBody, CardHeader, Form, FormGroup, Input, Media  } from 'reactstrap';
import { Breadcrumbs, Btn, H4 } from '../../../../AbstractElements';
import Loader from '../../../../Layout/Loader'
import DataTable from 'react-data-table-component';
// import { doctortabledata, tableColumns } from '../../../../Data/Doctor';
import { useNavigate } from 'react-router';
import { Navigator } from '../../../../Data/Table/Defaultdata';
const SlotDetails = () =>{

  const navigate = useNavigate()

  const slottabledata = [
    {
        id: 1,
        branch: 
        // <Media className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: `${user1}`, alt: 'Generic placeholder image' }} />
            <Media body className="align-self-center">
                <div className="f-w-700 font-success">Coimbatore</div>
            </Media>,
        // {/* </Media>, */}
        // date: '2023/04/27',
        day:  <span> Monday to Friday</span>,
        // day:  <span> #PX0101 <i className="fa fa-pencil"></i></span>,
        starttime: "9:00 am",
        endtime: '7:00 pm',
        holiday: "Not a Holiday",
        slots: <span className="f-w-700 badge badge-dark"> 5 mins</span>,
        action: <span>
        {/* <Btn attrBtn={{ style: style2, color: 'success', className: 'btn btn-xs', type: 'button' }}>Edit </Btn> */}
        <Navigator to={`${process.env.PUBLIC_URL}/settings/managetimeslot/:layout`}/>
      </span>
        // budget: '$3142.00',

    },
];

 const tableColumns = [
    {
        name: '#',
        selector: row => row['id'],
        sortable: true,
        center: false,
    },
    {
        name: 'Branch Name',
        selector: row => row['branch'],
        sortable: true,
        center: false,
    },
    {
        name: 'Week Day',
        selector: row => row['day'],
        sortable: true,
        center: true,
    },
    {
      name: 'Start Time',
      selector: row => `${row.starttime}`,
      sortable: true,
      center: true,
  },
    {
      name: 'End Time',
      selector: row => `${row.endtime}`,
      sortable: true,
      center: true,
  },
    {
        name: 'Holiday Status',
        selector: row => row['holiday'],
        sortable: true,
        center: true,
    },
    {
        name: 'Time Slots',
        selector: row => row['slots'],
        sortable: true,
        center: true,
    },
    
    {
        name: 'Action',
        selector: row => row['action'],
        sortable: false,
        center: true,
    },
];

  const [searchKeyword, setSearchKeyword] = useState('');
  const handleSearchKeyword = (keyword) => {
      setSearchKeyword(keyword);
      // searchMember(keyword);
  };

  const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);
    const [data, setData] = useState(slottabledata);

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handleDelete = () => {
        if (window.confirm(`Are you sure you want to delete:\r ${selectedRows.map(r => r.title)}?`)) {
            setToggleDelet(!toggleDelet);

            setData(data.filter((item) => selectedRows.filter((elem) => elem.id === item.id).length > 0 ? false : true));
            setSelectedRows('');
        }
    };
  return (
    <Suspense fallback={<Loader/>}>
    <Card>
       <Breadcrumbs mainTitle='Slot Details' parent='Dashboard' title='slotdetails' />
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          <Fragment>
  <div className="search">
    <Form className="theme-form">
      <FormGroup className="form-group">
        <div className="input-group">
          <Input
            className="form-control"
            type="text"
            placeholder="search"
            defaultValue={searchKeyword}
            onChange={(e) => handleSearchKeyword(e.target.value)}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <i className="fa fa-search"></i>
            </span>
          </div>
        </div>
      </FormGroup>
    </Form>
  </div>
</Fragment>
          <div className='card-header-right-icon'>
            {/* <DropdownCommon dropdownMain={{ className: 'icon-dropdown', direction: 'start' }} options={DailyDropdown} iconName='icon-more-alt' btn={{ tag: 'span' }} /> */}
            <div className='card-header-right-icon'>
            <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary', onClick: ()=> navigate(`${process.env.PUBLIC_URL}/settings/managetimeslot/:layout`)}}>+ Manage Time Slot</Btn>
          </div>
          </div>
        </div>
      </CardHeader>
      <CardBody className='pt-0 campaign-table'>
        <div className='recent-table table-responsive currency-table'>
        <Fragment>
        {(selectedRows.length !== 0) &&
                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delet Selected Data..!</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                </div>
            }
        <DataTable
                data={data}
                columns={tableColumns}
                striped={true}
                center={true}
                pagination
                selectableRows
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
            />
            </Fragment>
        </div>
      </CardBody>
    </Card>
    </Suspense>
  );
}

export default SlotDetails